import Vue from 'vue'
import VueRouter from 'vue-router'
import Layout from '@/Layout/index.vue'
// import store from '@/store'

import userManage from './modules/userManage'
import order from './modules/order'
import business from './modules/business'
import product from './modules/product'
import authConfiguration from './modules/authConfiguration'
import businessConfiguration from './modules/businessConfiguration'
import dataSummarization from './modules/data-summarization';
import h5UserManage from './modules/h5UserManage'
import productManage from './modules/productManage'

Vue.use(VueRouter)

export const routes = [
  {
    path: '/login',
    name: 'Login',
    hidden: true,
    meta: { notNeedAuth: true },
    component: () => import('@/views/login/login.vue'),
  },
  {
    path: '/404',
    name: 'NotFund',
    hidden: true,
    meta: { hidden: true },
    component: () => import('@/views/Error/404.vue'),
  },
]
export const permissionRoutes = [
  {
    path: '/',
    name: 'Root',
    redirect: '/home',
    component: Layout,
    children: [
      {
        path: 'home',
        name: 'Home',
        hidden: true,
        meta: { title: '首页', icon: 'el-icon-s-home', hidden: true, fixed: true ,requireAuth: true },
        component: () => import('@/views/home/home.vue'),
      },
    ],
  },
  authConfiguration,
  businessConfiguration,
  userManage,
  h5UserManage,
  business,
  product,
  order,
  dataSummarization,
  productManage,
  {
    path: '*',
    name: 'Error',
    hidden: true,
    redirect: '/404',
  },
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes,
})

export function resetRouter() {
  const newRouter = new VueRouter({
    scrollBehavior: () => ({ y: 0 }),
    routes: routes,
  })
  router.matcher = newRouter.matcher
}

router.beforeEach((to, from, next) => {
  if (to.meta.requireAuth) {
    var token = localStorage.getItem("token");
    if (token) {
      next();
    }else { 
      next({
          path: '/login',//返回登录界面
      })
    }
  } else {
    next();
  }
  // const whiteList = ['Login', 'NotFund']
  // const token = localStorage.getItem("token")
  // if (!token && whiteList.indexOf(to.name) === -1) {
  //   next({ name: 'Login' })
  // } else {
  //   next()
  // }
})

// router.afterEach((to) => {
//   if (to.name && to.meta.needCache) {
//     store.commit('tagsView/ADD_CACHE_VIEW', to.name)
//   }

//   if (to.meta === undefined || to.meta.notNeedAuth) {
//     return
//   }

//   if (to.meta.fixed) {
//     store.dispatch('tagsView/addFixedVisitedView', {
//       name: to.name,
//       fullPath: to.fullPath,
//       meta: to.meta,
//     })
//   } else {
//     store.commit('tagsView/ADD_VISITED_VIEW', {
//       name: to.name,
//       fullPath: to.fullPath,
//       meta: to.meta,
//     })
//   }
// })

export default router
